import React, { useState, useEffect } from 'react';
import Loading from '../Loading';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  TablePagination,
} from '@mui/material';
import Swal from 'sweetalert2';
import {
  Delete as DeleteIcon,
  BorderColor as BorderColorIcon,
  PersonAdd as PersonAddIcon,
  PeopleAlt as PeopleAltIcon,
} from '@mui/icons-material';
import AdminListApi from '../../service/admin.api';
import LinearLoading from '../LinearLoading';
import AdminDialog from '../dialogs/company/AdminDialog';
import { swalErrorBtn, swalSuccessBtn } from '../../helpers/swalHelper';

const TableCompanyAdmin = ({ tax_id, companyData2, isLinearLoading }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialogAdmin, setOpenDialogAdmin] = useState(false);
  const [adminData, setAdminData] = useState({});

  useEffect(() => {
    if (companyData2.length > 0) {
      setRows(companyData2.filter((admin) => admin.tax_id === tax_id));
    }
  }, [companyData2, tax_id]);

  const handleOpenDialog = (row) => {
    setAdminData(row);
    setOpenDialogAdmin(true);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeleteRow = async (_id) => {
    const confirmResult = await Swal.fire({
      title: 'ยืนยันการลบรายการ?',
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#4FA893',
      confirmButtonText: 'ตกลง',
      denyButtonText: 'ยกเลิก',
    });

    if (confirmResult.isConfirmed) {
      setIsLoading(true);
      try {
        await AdminListApi.deleteAdminApi(_id);

        setRows(rows.filter((row) => row._id !== _id));
        Swal.fire('ลบรายการสำเร็จ', '', 'success');
      } catch (error) {
        console.error('Error deleting admin:', error);
        Swal.fire('ลบรายการไม่สำเร็จ', '', 'error');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSubmitAdmin = async (data) => {
    try {
      const id = data?._id
      const name = data?.name
      const oneMail = data?.one_mail
      const admin = {
        name: name,
        one_mail: oneMail
      }

      await AdminListApi.updateAdminApi(id, admin);
      setRows((prevRows) =>
        prevRows.map((row) =>
          row._id === id
            ? { ...row, name: name, one_mail: oneMail }
            : row,
        ),
      );
      setOpenDialogAdmin(false)
      swalSuccessBtn({ title: `บันทึกข้อมูลเรียบร้อยแล้ว` });
    } catch (error) {
      console.log("error :", error);
      swalErrorBtn({ title: `บันทึกรายการไม่สำเร็จ` });
    }
  }

  return (
    <div className="px-2 mt-6">
      <Loading isLoading={isLoading} />
      <TableContainer
        sx={{
          maxWidth: '98%',
          minWidth: '800px',
          margin: '0 auto',
          overflowX: 'auto',
        }}
        component={Paper}
      >
        { <LinearLoading isLinearLoading={isLinearLoading} /> }
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">ลำดับ</TableCell>
              <TableCell align="center">ชื่อ-นามสกุล</TableCell>
              <TableCell align="center">One Mail</TableCell>
              <TableCell align="center">แก้ไขแอดมิน</TableCell>
              <TableCell align="center">ลบรายการ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={row._id}>
                  <TableCell align="center">
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">{row.one_mail}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="แก้ไขแอดมิน" arrow>
                      <IconButton
                        onClick={() => handleOpenDialog(row)}
                      >
                        <BorderColorIcon style={{ color: '#4FA893' }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="ลบรายการ" arrow>
                      <IconButton onClick={() => handleDeleteRow(row._id)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      
      <AdminDialog
        open={openDialogAdmin}
        onClose={() => setOpenDialogAdmin(false)}
        mode='edit'
        defaultValues={adminData}
        onSubmit={handleSubmitAdmin}
      />
    </div>
  );
};

export default TableCompanyAdmin;
